export const PAYMENT_FLOW = {
  BOOKING: 'Booking Payment Flow',
  FULL: 'Full Payment Flow',
} as const;

export type PaymentFlow = (typeof PAYMENT_FLOW)[keyof typeof PAYMENT_FLOW];

export const PAYMENT_METHOD_ONLINE = 'Online Payment';
export const DELIVERY_SOURCE_PORTAL = 'portal';

export function toAmountNumber(value: unknown): number {
  if (value === null || value === undefined || value === '') {
    return 0;
  }
  const parsed =
    typeof value === 'number'
      ? value
      : Number(String(value).replace(/[^0-9.-]/g, ''));
  return Number.isFinite(parsed) ? parsed : 0;
}

export function extractPriceBreakup(res: any): any | null {
  if (!res) {
    return null;
  }
  const data = res.data ?? res;
  if (data?.get_price_breakup) {
    return data.get_price_breakup;
  }
  if (data?.price_breakup) {
    return data.price_breakup;
  }
  if (data && (data.total_amount != null || data.scrap_booking_amount != null)) {
    return data;
  }
  return null;
}

export function getOnlinePaymentFields(options: {
  payFullAmount: boolean;
  bookingAmount?: unknown;
  totalAmount?: unknown;
}): { payment_flow: PaymentFlow; online_amount: number } {
  const bookingAmount = toAmountNumber(options.bookingAmount);
  const totalAmount = toAmountNumber(options.totalAmount);
  const payFullAmount = !!options.payFullAmount;

  return {
    payment_flow: payFullAmount ? PAYMENT_FLOW.FULL : PAYMENT_FLOW.BOOKING,
    online_amount:!payFullAmount && bookingAmount > 0 ? bookingAmount : totalAmount,
  };
}

export function appendOnlinePaymentFields(
  formData: FormData,
  fields: { payment_flow: string; online_amount: number },
): void {
  formData.append('payment_method', PAYMENT_METHOD_ONLINE);
  formData.append('payment_flow', fields.payment_flow || '');
  formData.append('online_amount', String(fields.online_amount));
  formData.append('delivery_source', DELIVERY_SOURCE_PORTAL);
}

export function assignPaymentFlow(
  payload: Record<string, unknown>,
  paymentFlow: string,
): void {
  payload['payment_flow'] = paymentFlow || '';
}
